import React, { useState, useEffect } from "react";
import MainPage from "./ClientSide/pages/MainPage/MainPage";
import ClientRoute from "./ClientSide/components/ClientRoute";
import { Route, Switch } from "react-router-dom";
import AdminRoute from "./AdminSide/Components/AdminRoute";
import { TrustedCompanies } from "./AdminSide/Pages/TrustedCompanies/TrustedCompanies";
import { AdminServices } from "./AdminSide/Pages/Services/Services";
import About from "./ClientSide/pages/AboutUs/About";
import Services from "./ClientSide/pages/Services/Services";
import Login from "./AdminSide/Pages/Login/Login";
import { MainSitePage } from "./AdminSide/Pages/MainSitePage/MainSitePage";
import { NotFoundPage } from "./ClientSide/pages/OtherPages/NotFoundPage";
import Contact from "./ClientSide/pages/Contact/Contact";
import { Projects } from "./AdminSide/Pages/Projects/Projects";
import ProjectsUs from "./ClientSide/pages/Projects/Projects";
import { BrowserRouter } from "react-router-dom";
import FetchApi from "./AdminSide/Pages/Login/FetchApi";
import { BASEURL } from "./AdminSide/Components/Constants";
import { HashRouter } from "react-router-dom";

function App() {
  const [ourTeam, setOurTeam] = useState([]);
  const getTeam = async () => {
    return await FetchApi(BASEURL + "get_team.php", "GET");
  };

  useEffect(() => {
    getTeam().then((res) => {
      setOurTeam(res && res.data);
    });
  }, []);
  return (
    <HashRouter>
      <Switch>
        <Route exact path="/contact" component={Contact} />
        {/*_______ Admin Routes _______*/}
        <ClientRoute exact path="/login" component={Login} />
        <AdminRoute exact path="/admin" component={MainSitePage} />
        <AdminRoute exact path="/admin/main" component={MainSitePage} />
        <AdminRoute exact path="/admin/projects" component={Projects} />
        <AdminRoute
          exact
          path="/admin/companies"
          component={TrustedCompanies}
        />
        <AdminRoute exact path="/admin/services" component={AdminServices} />
        <AdminRoute exact path="/admin/aboutUs" component={About} />

        {/*_______ Client Routes _______*/}
        <ClientRoute exact path="/services" component={Services} />
        <ClientRoute exact path="/" component={MainPage} />
        <ClientRoute
          exact
          ourTeam={ourTeam}
          path="/aboutUs"
          component={About}
        />
        <ClientRoute exact path="/projects" component={ProjectsUs} />
        <Route component={NotFoundPage} />
      </Switch>
    </HashRouter>
  );
}

export default App;
